import styles from './LastProduct.module.css';

export const LastProduct = ({ data }) => {
  const getStatus = (status) => {
    switch (status) {
      case 1:
        return <div className={`${styles.status} ${styles.inWork}`}>В работе</div>;
      case 2:
        return <div className={`${styles.status} ${styles.finished}`}>Завершен</div>;
      case 3:
        return <div className={`${styles.status} ${styles.cancelled}`}>Отменен</div>;
      default:
        return <div className="var">-</div>;
    }
  };

  return (
    <div className="col-md-6">
      <div className="goods mb-3">
        <div className="left">
          <div className="goods-info">
            <div className="name">Заказ #{data.id}</div>
            <div className="desc">
              {data.address?.city}, {data.address?.addressLine1}
            </div>
          </div>
        </div>

        <div className="right">
          <div className="title">Статус</div>
          {getStatus(data.status)}
        </div>

        <div className="right">
          <div className="title">Сумма заказа</div>
          <div className="cost">
            {data.totalSum || 'Нет данных'} {data.currency?.symbol}
          </div>
        </div>
      </div>
    </div>
  );
};
